import React from 'react';
import moment from 'moment';
import { v4 as uuid } from 'uuid';

import { DELIVERY_STATUS_ENUM_TRANSKEY } from '../../../enums/nf-status';

import {
  Container,
  ContainerStatus,
  ContainerSubstatus,
  IconContainer,
  StatusName,
  SubDescription,
  SubstatusContent,
  SubtitleText,
} from './styles';
import { Colors } from '../../../constants';
import { IconsTMS, IconsWMS } from './Icons/IconsStatus';

const splitBranchName = (branchName) => {
  if (!branchName) return { source: '', destination: '' };
  const parts = branchName.split(' - ');
  const mid = Math.floor(parts.length / 2);
  return {
    source: parts.slice(0, mid).join(' - '),
    destination: parts.slice(mid).join(' - '),
  };
};

function SingleStatus({
  deliveryType,
  isWMS,
  stepType,
  changedStatusAt,
  notHired,
  first,
  last,
  title,
  isMobile,
  notStarted,
  completed,
  onHold,
  inProgress,
  vertical,
  transfer,
  renderBottom,
  transfers,
}) {
  const isDeliveryType = deliveryType !== null && deliveryType !== undefined;

  const getColor = () => {
    if (completed) {
      return Colors.SECONDARY_LIGHT_DARK;
    } else if (inProgress || onHold) {
      return Colors.PRIMARY_BLUE;
    } else if (notStarted) {
      return Colors.GREY_150;
    }
  }

  const getColorsRadios1 = () => {
    if (completed) {
      return Colors.PRIMARY_LIGHT_BLUE;
    } else if (inProgress || onHold) {
      return Colors.PRIMARY_BLUE;
    } else if (notStarted) {
      return Colors.GREY_150;
    }
  }

  const getColorsRadios2 = () => {
    if (completed || inProgress || onHold) {
      return Colors.PRIMARY_LIGHTER_BLUE;
    } else if (notStarted) {
      return Colors.GREY_150;
    }
  }

  const getIconsWMS = (stepType) => {
    if (IconsWMS[stepType]) {
      return IconsWMS[stepType]({
        uuid: uuid(), 
        radiosColor1: getColorsRadios1(), 
        radiosColor2: getColorsRadios2(), 
        color: getColor()  
      })
    }
  }

  const getIconsTMS = (stepType) => {
    if (IconsTMS[stepType]) {
      return IconsTMS[stepType]({
        uuid: uuid(), 
        radiosColor1: getColorsRadios1(), 
        radiosColor2: getColorsRadios2(), 
        color: getColor() 
      })
    }
  }

  return (
    <Container vertical={vertical} isMobile={isMobile}>
      <IconContainer 
        first={!first} 
        last={!last} 
        vertical={vertical} 
        grayLine={notStarted || notHired}
      >
        {isWMS ? (
          <>
            {getIconsWMS(stepType)}
          </> 
        ) : (
          <>
            {getIconsTMS(stepType)}
          </>
        )}
      </IconContainer>

      <ContainerStatus vertical={vertical}>
        <StatusName 
          activeStatus={inProgress || onHold} 
          notStarted={notStarted} 
          vertical={vertical}      
        >
          {title}
        </StatusName>
        <SubtitleText uppercase vertical={vertical}>
          {!transfer && (inProgress || onHold) ? 'Em andamento' : ''}
          {transfer && !vertical && 'Transferência'}
          {notStarted ? 'Pendente' : ''}
        </SubtitleText>

        {transfer && vertical && transfers && transfers.length > 0 ? (
          <ContainerSubstatus>
            {transfers.map((leg, i) => {
              const { source, destination } = splitBranchName(leg.branchName);
              const hasArrival = leg.arrivalBranch && (leg.arrivalBranch.changedStatusAt || destination);
              return (
                <React.Fragment key={i}>
                  <SubstatusContent>
                    <SubDescription active>Transporte</SubDescription>
                    {source && <SubDescription>{source}</SubDescription>}
                    {leg.changedStatusAt && (
                      <SubDescription>
                        {moment(leg.changedStatusAt).format('DD/MM/YYYY HH:mm')}
                      </SubDescription>
                    )}
                  </SubstatusContent>
                  {hasArrival && (
                    <SubstatusContent>
                      <SubDescription active>Chegada na filial</SubDescription>
                      {destination && <SubDescription>{destination}</SubDescription>}
                      {leg.arrivalBranch && leg.arrivalBranch.changedStatusAt ? (
                        <SubDescription>
                          {moment(leg.arrivalBranch.changedStatusAt).format('DD/MM/YYYY HH:mm')}
                        </SubDescription>
                      ) : (
                        <SubDescription>Pendente</SubDescription>
                      )}
                    </SubstatusContent>
                  )}
                </React.Fragment>
              );
            })}
          </ContainerSubstatus>
        ) : null}

        {isDeliveryType ? (
          <SubtitleText uppercase>
            {DELIVERY_STATUS_ENUM_TRANSKEY[deliveryType]}
          </SubtitleText>
        ) : null}

        {vertical && !transfer && changedStatusAt && (
          <SubtitleText>
            {moment(changedStatusAt).format('DD/MM/YYYY HH:mm')}
          </SubtitleText>
        )}

        {!vertical && changedStatusAt && (
          <SubtitleText>
            {moment(changedStatusAt).format('DD/MM/YYYY HH:mm')}
          </SubtitleText>
        )}
        {renderBottom && renderBottom}
      </ContainerStatus>
    </Container>
  );
}

export default SingleStatus;
